<section>
  <div class="row" *ngIf="!isOpened">
    <div class="col-12 col-md-12">
      <div class="row container-style">
        <div class="col-12 col-md-12">
          <p>Este proceso busca todos los precios por c.costos que la obra y el cliente esten activos dentro la
            compañía y crea cotizaciones para cada obra con una solución por cada c.costos, donde cada artículos que
            haya en precios por c.costos, será una linea del despiece de dicha solución.</p>
        </div>
        <form class="needs-validation" novalidate errorTailor>
          <div class="row">
            <div class="col field-company">
              <app-custom-autocomplete [labelText]="'Compañía'" [list]="listCompany" [required]="true"
                (onChangeSelect)="getCompanyId($event)">
              </app-custom-autocomplete>
            </div>
            <div class="col field-buttons">
              <app-custom-button [label]="'Implementar'" [severity]="'primary'" [width]="'5rem'" [variant]="undefined"
                (onClick)="createQuotationsFromCostCenterPrices()"></app-custom-button>
              <app-custom-button [label]="'Revertir'" [severity]="'danger'" [variant]="undefined"
                (onClick)="revertImplementQuotation()"></app-custom-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="container-form d-flex flex-row message-error" *ngIf="isOpened">
    <span class="material-icons me-1"> highlight_off </span>
    <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
  </div>
</section>